<template>
  <div>
    Waiting
  </div>
</template>
<script setup>
import {onMounted} from "vue";
import AuthService from "@/utilities/services/AuthService";

onMounted(async ()=> {
  const oAuthService = new AuthService.getDefaultInstance();
  const oAuthUser = await oAuthService.loginSilent();
  // console.log("refresh resp on silent callback page", oAuthUser)
  if(!oAuthUser) return null
})

</script>
